import { render, staticRenderFns } from "./TableDuration.vue?vue&type=template&id=86fb5e3a&scoped=true&"
import script from "./TableDuration.vue?vue&type=script&lang=js&"
export * from "./TableDuration.vue?vue&type=script&lang=js&"
import style0 from "./TableDuration.vue?vue&type=style&index=0&id=86fb5e3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fb5e3a",
  null
  
)

export default component.exports